// extracted by mini-css-extract-plugin
export var phone = "_4s-0";
export var phoneDragging = "_4s-1";